export default __webpack_public_path__ + "static/media/copy-text.c7e4dc1d.svg";